import { Link } from "react-router-dom";
import Cookies from "universal-cookie";
const Sidebar = () => {
  const cookies = new Cookies();
  const isHref = (pageStr, secondPageStr, thirdPageStr) => {
    if (
      window.location.href.split("/").includes(pageStr) ||
      window.location.href.split("/").includes(secondPageStr) || 
      window.location.href.split("/").includes(thirdPageStr)
    ) {
      return true;
    } else {
      return false;
    }
  };
  const handleLogout = () => {
    window.sessionStorage.clear();
    cookies.remove("admintoken", { path: "/" });
  };

  const dentistArr = ["consultations-requests", "member", "calendar"];

  return (
    <div className="vertical-menu">
      <div data-simplebar="" className="h-100">
        {/* <!--- Sidemenu --> */}
        <div id="sidebar-menu">
          {/* <!-- Left Menu Start --> */}
          <div className="side-panel-flex-direction">
            <ul className="metismenu list-unstyled mt-4" id="side-menu">
              {window.sessionStorage.getItem("role") == "dentist" ? (
                <>
                  <li className="mm-active">
                    <Link
                      className={
                        isHref("consultations-requests")
                          ? "waves-effect active"
                          : "waves-effect"
                      }
                      to="/admin/consultations-requests"
                    >
                      <i>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 24 24"
                        >
                          <g fill="currentColor">
                            <circle
                              cx="12"
                              cy="6"
                              r="4"
                              fill={
                                isHref(
                                  "blog",
                                  "consultations-requests",
                                  "viewBlog"
                                )
                                  ? "#1B95BC"
                                  : "#a6b0cf"
                              }
                            />
                            <path
                              d="M20 17.5c0 2.485 0 4.5-8 4.5s-8-2.015-8-4.5S7.582 13 12 13s8 2.015 8 4.5Z"
                              fill={
                                isHref(
                                  "blog",
                                  "consultations-requests",
                                  "viewBlog"
                                )
                                  ? "#1B95BC"
                                  : "#a6b0cf"
                              }
                            />
                          </g>
                        </svg>
                      </i>
                      <span
                        style={{
                          color: isHref("consultations-requests")
                            ? "#1B95BC"
                            : "#a6b0cf",
                          fontWeight: isHref("consultations-requests")
                            ? "600"
                            : "400",
                        }}
                        key="t-dashboards"
                      >
                        New Requests
                      </span>
                    </Link>
                  </li>
                  <li className="mm-active">
                    <Link
                      className={
                        isHref("consultations")
                          ? "waves-effect active"
                          : "waves-effect"
                      }
                      to="/admin/consultations-all"
                    >
                      <i>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M20 4a2 2 0 0 1 2 2v10c0 1.11-.89 2-2 2h4v2H0v-2h4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h16m0 2H4v10h16V6m-8 6c2.21 0 4 .9 4 2v1H8v-1c0-1.1 1.79-2 4-2m0-5a2 2 0 1 1 0 4c-1.11 0-2-.89-2-2s.9-2 2-2Z"
                            fill={
                              isHref("blog", "consultations-all", "viewBlog")
                                ? "#1B95BC"
                                : "#a6b0cf"
                            }
                          />
                        </svg>
                      </i>
                      <span
                        style={{
                          color: isHref("consultations-all")
                            ? "#1B95BC"
                            : "#a6b0cf",
                          fontWeight: isHref("consultations-all")
                            ? "600"
                            : "400",
                        }}
                        key="t-dashboards"
                      >
                        Consultations
                      </span>
                    </Link>
                  </li>
                  <li className="mm-active">
                    <Link
                      className={
                        isHref("member", "memberdetails")
                          ? "waves-effect active"
                          : "waves-effect"
                      }
                      to="/admin/member"
                    >
                      <i>
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="12"
                            cy="10"
                            r="3"
                            stroke={
                              isHref("member", "memberdetails")
                                ? "#1B95BC"
                                : "#a6b0cf"
                            }
                            strokeWidth="2"
                            strokeLinecap="round"
                          ></circle>
                          <circle
                            cx="12"
                            cy="12"
                            r="9"
                            stroke={
                              isHref("member", "memberdetails")
                                ? "#1B95BC"
                                : "#a6b0cf"
                            }
                            strokeWidth="2"
                          ></circle>
                          <path
                            d="M17.7805 18.8264C17.9076 18.7566 17.9678 18.6055 17.914 18.4708C17.5284 17.5045 16.7856 16.6534 15.7814 16.0332C14.6966 15.3632 13.3674 15 12 15C10.6326 15 9.30341 15.3632 8.21858 16.0332C7.21444 16.6534 6.4716 17.5045 6.08598 18.4708C6.03223 18.6055 6.09236 18.7566 6.21948 18.8264C9.81971 20.803 14.1803 20.803 17.7805 18.8264Z"
                            fill={
                              isHref("member", "memberdetails")
                                ? "#1B95BC"
                                : "#a6b0cf"
                            }
                          ></path>
                        </svg>
                      </i>
                      <span
                        style={{
                          color: isHref("member", "memberdetails")
                            ? "#1B95BC"
                            : "#a6b0cf",
                          fontWeight: isHref("member", "memberdetails")
                            ? "600"
                            : "400",
                        }}
                        key="t-dashboards"
                      >
                        Members
                      </span>
                    </Link>
                  </li>
                  <li className="mm-active">
                    <Link
                      to="/admin/transactions"
                      className={
                        isHref("transactions")
                          ? "waves-effect active"
                          : "waves-effect"
                      }
                    >
                      <i className="">
                        <svg
                          width="17"
                          height="18"
                          viewBox="0 0 19 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17.1667 19H7.16675"
                            stroke={
                              isHref("transactions") ? "#1B95BC" : "#a6b0cf"
                            }
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M3.66675 14H13.1667C15.0524 14 15.9952 14 16.581 13.4142C17.1667 12.8284 17.1667 11.8856 17.1667 10V5C17.1667 3.11438 17.1667 2.17157 16.581 1.58579C15.9952 1 15.0524 1 13.1667 1H5.16675C3.28113 1 2.33832 1 1.75253 1.58579C1.16675 2.17157 1.16675 3.11438 1.16675 5V16.5C1.16675 15.1193 2.28604 14 3.66675 14ZM13.581 7.41421C14.362 6.63317 14.362 5.36684 13.581 4.58579C12.7999 3.80474 11.5336 3.80474 10.7525 4.58579L8.16675 7.17157L7.58096 6.58579C6.79991 5.80474 5.53358 5.80474 4.75253 6.58579C3.97149 7.36683 3.97149 8.63316 4.75253 9.41421L6.04543 10.7071C7.217 11.8787 9.1165 11.8787 10.2881 10.7071L13.581 7.41421Z"
                            fill={
                              isHref("transactions") ? "#1B95BC" : "#a6b0cf"
                            }
                          />
                          <path
                            d="M16.581 13.4142L15.8739 12.7071L15.8739 12.7071L16.581 13.4142ZM16.581 1.58579L15.8739 2.29289L15.8739 2.29289L16.581 1.58579ZM13.581 4.58579L14.2881 3.87868L14.2881 3.87868L13.581 4.58579ZM13.581 7.41421L12.8739 6.70711L13.581 7.41421ZM10.7525 4.58579L10.0454 3.87868L10.7525 4.58579ZM8.16675 7.17157L7.45964 7.87868L8.16675 8.58579L8.87385 7.87868L8.16675 7.17157ZM7.58096 6.58579L6.87385 7.29289H6.87386L7.58096 6.58579ZM4.75253 6.58579L5.45964 7.29289L5.45964 7.29289L4.75253 6.58579ZM4.75253 9.41421L5.45964 8.70711V8.70711L4.75253 9.41421ZM6.04543 10.7071L5.33832 11.4142L6.04543 10.7071ZM10.2881 10.7071L9.58096 10L10.2881 10.7071ZM13.1667 13H3.66675V15H13.1667V13ZM15.8739 12.7071C15.7977 12.7832 15.6618 12.8774 15.228 12.9357C14.7655 12.9979 14.1378 13 13.1667 13V15C14.0813 15 14.8678 15.0021 15.4945 14.9179C16.1501 14.8297 16.7784 14.631 17.2881 14.1213L15.8739 12.7071ZM16.1667 10C16.1667 10.9711 16.1646 11.5988 16.1024 12.0613C16.0441 12.495 15.95 12.631 15.8739 12.7071L17.2881 14.1213C17.7977 13.6117 17.9965 12.9833 18.0846 12.3278C18.1689 11.701 18.1667 10.9145 18.1667 10H16.1667ZM16.1667 5V10H18.1667V5H16.1667ZM15.8739 2.29289C15.95 2.36902 16.0441 2.50496 16.1024 2.9387C16.1646 3.40121 16.1667 4.02892 16.1667 5H18.1667C18.1667 4.08546 18.1689 3.29896 18.0846 2.67221C17.9965 2.01669 17.7977 1.38834 17.2881 0.878679L15.8739 2.29289ZM13.1667 2C14.1378 2 14.7655 2.00212 15.228 2.06431C15.6618 2.12262 15.7977 2.21677 15.8739 2.29289L17.2881 0.87868C16.7784 0.369017 16.1501 0.170272 15.4945 0.0821405C14.8678 -0.00212371 14.0813 0 13.1667 0V2ZM5.16675 2H13.1667V0H5.16675V2ZM2.45964 2.29289C2.53577 2.21677 2.67171 2.12262 3.10545 2.06431C3.56796 2.00212 4.19567 2 5.16675 2V0C4.25221 0 3.46571 -0.00212371 2.83896 0.0821405C2.18344 0.170272 1.55509 0.369017 1.04543 0.87868L2.45964 2.29289ZM2.16675 5C2.16675 4.02892 2.16887 3.40121 2.23105 2.9387C2.28937 2.50496 2.38352 2.36902 2.45964 2.29289L1.04543 0.87868C0.535766 1.38834 0.33702 2.01669 0.248889 2.67221C0.164624 3.29896 0.166748 4.08546 0.166748 5H2.16675ZM2.16675 16.5V5H0.166748V16.5H2.16675ZM3.66675 13C1.73375 13 0.166748 14.567 0.166748 16.5H2.16675C2.16675 15.6716 2.83832 15 3.66675 15V13ZM12.8739 5.29289C13.2644 5.68342 13.2644 6.31658 12.8739 6.70711L14.2881 8.12132C15.4596 6.94975 15.4596 5.05025 14.2881 3.87868L12.8739 5.29289ZM11.4596 5.29289C11.8502 4.90237 12.4833 4.90237 12.8739 5.29289L14.2881 3.87868C13.1165 2.70711 11.217 2.70711 10.0454 3.87868L11.4596 5.29289ZM8.87385 7.87868L11.4596 5.29289L10.0454 3.87868L7.45964 6.46447L8.87385 7.87868ZM6.87386 7.29289L7.45964 7.87868L8.87385 6.46447L8.28807 5.87868L6.87386 7.29289ZM5.45964 7.29289C5.85017 6.90237 6.48333 6.90237 6.87385 7.29289L8.28807 5.87868C7.1165 4.70711 5.217 4.70711 4.04543 5.87868L5.45964 7.29289ZM5.45964 8.70711C5.06912 8.31658 5.06912 7.68342 5.45964 7.29289L4.04543 5.87868C2.87385 7.05025 2.87385 8.94975 4.04543 10.1213L5.45964 8.70711ZM6.75253 10L5.45964 8.70711L4.04543 10.1213L5.33832 11.4142L6.75253 10ZM9.58096 10C8.79991 10.781 7.53358 10.781 6.75253 10L5.33832 11.4142C6.90042 12.9763 9.43308 12.9763 10.9952 11.4142L9.58096 10ZM12.8739 6.70711L9.58096 10L10.9952 11.4142L14.2881 8.12132L12.8739 6.70711ZM8.16675 18H3.66675V20H8.16675V18ZM0.166748 16.5C0.166748 18.433 1.73375 20 3.66675 20V18C2.83832 18 2.16675 17.3284 2.16675 16.5H0.166748Z"
                            fill={
                              isHref("transactions") ? "#1B95BC" : "#a6b0cf"
                            }
                          />
                        </svg>
                      </i>
                      <span
                        style={{
                          color: isHref("transactions") ? "#1B95BC" : "#a6b0cf",
                          fontWeight: isHref("transactions") ? "600" : "400",
                        }}
                        key="t-dashboards"
                      >
                        Transactions
                      </span>
                    </Link>
                  </li>
                  <li className="mm-active">
                    <Link
                      to="/admin/calendar"
                      className={
                        isHref("calendar")
                          ? "waves-effect active"
                          : "waves-effect"
                      }
                    >
                      <i className="">
                        <svg
                          height="20"
                          viewBox="0 0 24 24"
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20,8 L20,5 L18,5 L18,6 L16,6 L16,5 L8,5 L8,6 L6,6 L6,5 L4,5 L4,8 L20,8 Z M20,10 L4,10 L4,20 L20,20 L20,10 Z M18,3 L20,3 C21.1045695,3 22,3.8954305 22,5 L22,20 C22,21.1045695 21.1045695,22 20,22 L4,22 C2.8954305,22 2,21.1045695 2,20 L2,5 C2,3.8954305 2.8954305,3 4,3 L6,3 L6,2 L8,2 L8,3 L16,3 L16,2 L18,2 L18,3 Z"
                            fill={isHref("calendar") ? "#1B95BC" : "#a6b0cf"}
                            fill-rule="evenodd"
                          />
                        </svg>
                      </i>
                      <span
                        style={{
                          color: isHref("calendar") ? "#1B95BC" : "#a6b0cf",
                          fontWeight: isHref("calendar") ? "600" : "400",
                        }}
                        key="t-dashboards"
                      >
                        Calendar
                      </span>
                    </Link>
                  </li>
                  <li className="mm-active">
                    <Link
                      to="/admin/report-issue"
                      className={
                        isHref("report-issue", "createAdmin")
                          ? "waves-effect active"
                          : "waves-effect"
                      }
                    >
                      <i className="">
                        <svg
                          width="17"
                          height="18"
                          viewBox="0 0 18 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M16.3259 2.77772L15.4944 3.33329V3.33329L16.3259 2.77772ZM16.3259 13.2223L15.4944 12.6667V12.6667L16.3259 13.2223ZM15.2223 14.3259L14.6667 13.4944H14.6667L15.2223 14.3259ZM11 14.9986L10.9956 13.9986C10.4451 14.001 10 14.4481 10 14.9986H11ZM11 15L11.8944 15.4472C11.9639 15.3084 12 15.1552 12 15H11ZM7 15H6C6 15.1552 6.03615 15.3084 6.10557 15.4472L7 15ZM7 14.9986H8C8 14.4481 7.55494 14.001 7.00436 13.9986L7 14.9986ZM2.77772 14.3259L3.33329 13.4944H3.33329L2.77772 14.3259ZM1.67412 13.2223L2.50559 12.6667L2.50559 12.6667L1.67412 13.2223ZM1.67412 2.77772L2.50559 3.33329L1.67412 2.77772ZM2.77772 1.67412L3.33329 2.50559L2.77772 1.67412ZM15.2223 1.67412L14.6667 2.50559L14.6667 2.50559L15.2223 1.67412ZM18 8C18 6.61635 18.0012 5.50334 17.9106 4.61264C17.8183 3.70523 17.6225 2.91829 17.1573 2.22215L15.4944 3.33329C15.7034 3.64604 15.8446 4.06578 15.9209 4.81505C15.9988 5.58104 16 6.57473 16 8H18ZM17.1573 13.7779C17.6225 13.0817 17.8183 12.2948 17.9106 11.3874C18.0012 10.4967 18 9.38365 18 8H16C16 9.42527 15.9988 10.419 15.9209 11.1849C15.8446 11.9342 15.7034 12.354 15.4944 12.6667L17.1573 13.7779ZM15.7779 15.1573C16.3238 14.7926 16.7926 14.3238 17.1573 13.7779L15.4944 12.6667C15.2755 12.9943 14.9943 13.2755 14.6667 13.4944L15.7779 15.1573ZM11.0044 15.9986C12.0785 15.9939 12.9763 15.9739 13.7267 15.8701C14.4931 15.7642 15.1699 15.5636 15.7779 15.1573L14.6667 13.4944C14.3934 13.6771 14.0378 13.8081 13.4528 13.889C12.8518 13.9721 12.0792 13.9939 10.9956 13.9986L11.0044 15.9986ZM12 15V14.9986H10V15H12ZM10.7889 17.6584L11.8944 15.4472L10.1056 14.5528L9 16.7639L10.7889 17.6584ZM7.21115 17.6584C7.94819 19.1325 10.0518 19.1325 10.7889 17.6584L9 16.7639L9 16.7639L7.21115 17.6584ZM6.10557 15.4472L7.21115 17.6584L9 16.7639L7.89443 14.5528L6.10557 15.4472ZM6 14.9986V15H8V14.9986H6ZM2.22215 15.1573C2.83014 15.5636 3.50685 15.7642 4.2733 15.8701C5.02368 15.9739 5.92154 15.9939 6.99564 15.9986L7.00436 13.9986C5.92075 13.9939 5.14815 13.9721 4.54716 13.889C3.96223 13.8081 3.60665 13.6771 3.33329 13.4944L2.22215 15.1573ZM0.842652 13.7779C1.20744 14.3238 1.6762 14.7926 2.22215 15.1573L3.33329 13.4944C3.00572 13.2755 2.72447 12.9943 2.50559 12.6667L0.842652 13.7779ZM0 8C0 9.38365 -0.0012089 10.4967 0.0893996 11.3874C0.181708 12.2948 0.377503 13.0817 0.842652 13.7779L2.50559 12.6667C2.29662 12.354 2.15535 11.9342 2.07913 11.1849C2.00121 10.419 2 9.42527 2 8H0ZM0.842652 2.22215C0.377503 2.91829 0.181708 3.70523 0.0893996 4.61264C-0.0012089 5.50334 0 6.61635 0 8H2C2 6.57473 2.00121 5.58104 2.07913 4.81505C2.15535 4.06578 2.29662 3.64604 2.50559 3.33329L0.842652 2.22215ZM2.22215 0.842652C1.6762 1.20744 1.20744 1.6762 0.842652 2.22215L2.50559 3.33329C2.72447 3.00572 3.00572 2.72447 3.33329 2.50559L2.22215 0.842652ZM8 0C6.61635 0 5.50334 -0.0012089 4.61264 0.0893996C3.70523 0.181708 2.91829 0.377503 2.22215 0.842652L3.33329 2.50559C3.64604 2.29662 4.06578 2.15535 4.81505 2.07913C5.58104 2.00121 6.57473 2 8 2V0ZM10 0H8V2H10V0ZM15.7779 0.842652C15.0817 0.377503 14.2948 0.181708 13.3874 0.0893996C12.4967 -0.0012089 11.3836 0 10 0V2C11.4253 2 12.419 2.00121 13.1849 2.07913C13.9342 2.15535 14.354 2.29662 14.6667 2.50559L15.7779 0.842652ZM17.1573 2.22215C16.7926 1.6762 16.3238 1.20744 15.7779 0.842652L14.6667 2.50559C14.9943 2.72447 15.2755 3.00572 15.4944 3.33329L17.1573 2.22215Z"
                            fill={
                              isHref("livechat", "chat") ? "#1B95BC" : "#a6b0cf"
                            }
                          />
                          <circle
                            cx="13"
                            cy="8"
                            r="1"
                            fill="#A3AED0"
                            stroke={
                              isHref("livechat", "chat") ? "#1B95BC" : "#a6b0cf"
                            }
                            strokeLinecap="round"
                          />
                          <circle
                            cx="9"
                            cy="8"
                            r="1"
                            fill="#A3AED0"
                            stroke={
                              isHref("livechat", "chat") ? "#1B95BC" : "#a6b0cf"
                            }
                            strokeLinecap="round"
                          />
                          <circle
                            cx="5"
                            cy="8"
                            r="1"
                            fill="#A3AED0"
                            stroke={
                              isHref("livechat", "chat") ? "#1B95BC" : "#a6b0cf"
                            }
                            strokeLinecap="round"
                          />
                        </svg>
                      </i>
                      <span
                        style={{
                          color: isHref("report-issue", "createAdmin")
                            ? "#1B95BC"
                            : "#a6b0cf",
                          fontWeight: isHref("report-issue", "createAdmin")
                            ? "600"
                            : "400",
                        }}
                        key="t-dashboards"
                      >
                        Report Issue
                      </span>
                    </Link>
                  </li>
                  <li className="mm-active">
                    <Link
                      to="/admin/report-issue"
                      className={
                        isHref("report-issue", "createAdmin")
                          ? "waves-effect active"
                          : "waves-effect"
                      }
                    >
                      <i className="">
                        <svg
                          width="17"
                          height="18"
                          viewBox="0 0 18 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M16.3259 2.77772L15.4944 3.33329V3.33329L16.3259 2.77772ZM16.3259 13.2223L15.4944 12.6667V12.6667L16.3259 13.2223ZM15.2223 14.3259L14.6667 13.4944H14.6667L15.2223 14.3259ZM11 14.9986L10.9956 13.9986C10.4451 14.001 10 14.4481 10 14.9986H11ZM11 15L11.8944 15.4472C11.9639 15.3084 12 15.1552 12 15H11ZM7 15H6C6 15.1552 6.03615 15.3084 6.10557 15.4472L7 15ZM7 14.9986H8C8 14.4481 7.55494 14.001 7.00436 13.9986L7 14.9986ZM2.77772 14.3259L3.33329 13.4944H3.33329L2.77772 14.3259ZM1.67412 13.2223L2.50559 12.6667L2.50559 12.6667L1.67412 13.2223ZM1.67412 2.77772L2.50559 3.33329L1.67412 2.77772ZM2.77772 1.67412L3.33329 2.50559L2.77772 1.67412ZM15.2223 1.67412L14.6667 2.50559L14.6667 2.50559L15.2223 1.67412ZM18 8C18 6.61635 18.0012 5.50334 17.9106 4.61264C17.8183 3.70523 17.6225 2.91829 17.1573 2.22215L15.4944 3.33329C15.7034 3.64604 15.8446 4.06578 15.9209 4.81505C15.9988 5.58104 16 6.57473 16 8H18ZM17.1573 13.7779C17.6225 13.0817 17.8183 12.2948 17.9106 11.3874C18.0012 10.4967 18 9.38365 18 8H16C16 9.42527 15.9988 10.419 15.9209 11.1849C15.8446 11.9342 15.7034 12.354 15.4944 12.6667L17.1573 13.7779ZM15.7779 15.1573C16.3238 14.7926 16.7926 14.3238 17.1573 13.7779L15.4944 12.6667C15.2755 12.9943 14.9943 13.2755 14.6667 13.4944L15.7779 15.1573ZM11.0044 15.9986C12.0785 15.9939 12.9763 15.9739 13.7267 15.8701C14.4931 15.7642 15.1699 15.5636 15.7779 15.1573L14.6667 13.4944C14.3934 13.6771 14.0378 13.8081 13.4528 13.889C12.8518 13.9721 12.0792 13.9939 10.9956 13.9986L11.0044 15.9986ZM12 15V14.9986H10V15H12ZM10.7889 17.6584L11.8944 15.4472L10.1056 14.5528L9 16.7639L10.7889 17.6584ZM7.21115 17.6584C7.94819 19.1325 10.0518 19.1325 10.7889 17.6584L9 16.7639L9 16.7639L7.21115 17.6584ZM6.10557 15.4472L7.21115 17.6584L9 16.7639L7.89443 14.5528L6.10557 15.4472ZM6 14.9986V15H8V14.9986H6ZM2.22215 15.1573C2.83014 15.5636 3.50685 15.7642 4.2733 15.8701C5.02368 15.9739 5.92154 15.9939 6.99564 15.9986L7.00436 13.9986C5.92075 13.9939 5.14815 13.9721 4.54716 13.889C3.96223 13.8081 3.60665 13.6771 3.33329 13.4944L2.22215 15.1573ZM0.842652 13.7779C1.20744 14.3238 1.6762 14.7926 2.22215 15.1573L3.33329 13.4944C3.00572 13.2755 2.72447 12.9943 2.50559 12.6667L0.842652 13.7779ZM0 8C0 9.38365 -0.0012089 10.4967 0.0893996 11.3874C0.181708 12.2948 0.377503 13.0817 0.842652 13.7779L2.50559 12.6667C2.29662 12.354 2.15535 11.9342 2.07913 11.1849C2.00121 10.419 2 9.42527 2 8H0ZM0.842652 2.22215C0.377503 2.91829 0.181708 3.70523 0.0893996 4.61264C-0.0012089 5.50334 0 6.61635 0 8H2C2 6.57473 2.00121 5.58104 2.07913 4.81505C2.15535 4.06578 2.29662 3.64604 2.50559 3.33329L0.842652 2.22215ZM2.22215 0.842652C1.6762 1.20744 1.20744 1.6762 0.842652 2.22215L2.50559 3.33329C2.72447 3.00572 3.00572 2.72447 3.33329 2.50559L2.22215 0.842652ZM8 0C6.61635 0 5.50334 -0.0012089 4.61264 0.0893996C3.70523 0.181708 2.91829 0.377503 2.22215 0.842652L3.33329 2.50559C3.64604 2.29662 4.06578 2.15535 4.81505 2.07913C5.58104 2.00121 6.57473 2 8 2V0ZM10 0H8V2H10V0ZM15.7779 0.842652C15.0817 0.377503 14.2948 0.181708 13.3874 0.0893996C12.4967 -0.0012089 11.3836 0 10 0V2C11.4253 2 12.419 2.00121 13.1849 2.07913C13.9342 2.15535 14.354 2.29662 14.6667 2.50559L15.7779 0.842652ZM17.1573 2.22215C16.7926 1.6762 16.3238 1.20744 15.7779 0.842652L14.6667 2.50559C14.9943 2.72447 15.2755 3.00572 15.4944 3.33329L17.1573 2.22215Z"
                            fill={
                              isHref("livechat", "chat") ? "#1B95BC" : "#a6b0cf"
                            }
                          />
                          <circle
                            cx="13"
                            cy="8"
                            r="1"
                            fill="#A3AED0"
                            stroke={
                              isHref("livechat", "chat") ? "#1B95BC" : "#a6b0cf"
                            }
                            strokeLinecap="round"
                          />
                          <circle
                            cx="9"
                            cy="8"
                            r="1"
                            fill="#A3AED0"
                            stroke={
                              isHref("livechat", "chat") ? "#1B95BC" : "#a6b0cf"
                            }
                            strokeLinecap="round"
                          />
                          <circle
                            cx="5"
                            cy="8"
                            r="1"
                            fill="#A3AED0"
                            stroke={
                              isHref("livechat", "chat") ? "#1B95BC" : "#a6b0cf"
                            }
                            strokeLinecap="round"
                          />
                        </svg>
                      </i>
                      <span
                        style={{
                          color: isHref("report-issue", "createAdmin")
                            ? "#1B95BC"
                            : "#a6b0cf",
                          fontWeight: isHref("report-issue", "createAdmin")
                            ? "600"
                            : "400",
                        }}
                        key="t-dashboards"
                      >
                        Report Issue
                      </span>
                    </Link>
                  </li>
                </>
              ) : (
                <>
                  <li className="mm-active">
                    <Link
                      className={
                        isHref("dashboard")
                          ? "waves-effect active"
                          : "waves-effect"
                      }
                      to="/admin/dashboard"
                    >
                      <i>
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.0001 19V14H14.0001V19C14.0001 19.55 14.4501 20 15.0001 20H18.0001C18.5501 20 19.0001 19.55 19.0001 19V12H20.7001C21.1601 12 21.3801 11.43 21.0301 11.13L12.6701 3.6C12.2901 3.26 11.7101 3.26 11.3301 3.6L2.9701 11.13C2.6301 11.43 2.8401 12 3.3001 12H5.0001V19C5.0001 19.55 5.4501 20 6.0001 20H9.0001C9.5501 20 10.0001 19.55 10.0001 19Z"
                            fill={isHref("dashboard") ? "#1B95BC" : "#a6b0cf"}
                          />
                        </svg>
                      </i>
                      <span
                        style={{
                          color: isHref("dashboard") ? "#1B95BC" : "#a6b0cf",
                          fontWeight: isHref("dashboard") ? "600" : "400",
                        }}
                        key="t-dashboards"
                      >
                        Dashboard
                      </span>
                    </Link>
                  </li>
                  {/* <li className="mm-active">
                    <Link
                      className={
                        isHref("consultations-requests")
                          ? "waves-effect active"
                          : "waves-effect"
                      }
                      to="/admin/consultations-requests"
                    >
                      <i>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 24 24"
                        >
                          <g fill="currentColor">
                            <circle
                              cx="12"
                              cy="6"
                              r="4"
                              fill={
                                isHref("consultations-requests")
                                  ? "#1B95BC"
                                  : "#a6b0cf"
                              }
                            />
                            <path
                              d="M20 17.5c0 2.485 0 4.5-8 4.5s-8-2.015-8-4.5S7.582 13 12 13s8 2.015 8 4.5Z"
                              fill={
                                isHref("consultations-requests")
                                  ? "#1B95BC"
                                  : "#a6b0cf"
                              }
                            />
                          </g>
                        </svg>
                      </i>
                      <span
                        style={{
                          color: isHref("consultations-requests")
                            ? "#1B95BC"
                            : "#a6b0cf",
                          fontWeight: isHref("consultations-requests")
                            ? "600"
                            : "400",
                        }}
                        key="t-dashboards"
                      >
                        New Requests
                      </span>
                    </Link>
                  </li> */}

                   {/* upcoming consultation  */}

                   <li className="mm-active">
                    <Link
                      className={
                        isHref("consultationsupcoming")
                          ? "waves-effect active"
                          : "waves-effect"
                      }
                      to="/admin/consultationsupcoming"
                    >
                      <i>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M20 4a2 2 0 0 1 2 2v10c0 1.11-.89 2-2 2h4v2H0v-2h4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h16m0 2H4v10h16V6m-8 6c2.21 0 4 .9 4 2v1H8v-1c0-1.1 1.79-2 4-2m0-5a2 2 0 1 1 0 4c-1.11 0-2-.89-2-2s.9-2 2-2Z"
                            fill={
                              isHref("consultationsupcoming")
                                ? "#1B95BC"
                                : "#a6b0cf"
                            }
                          />
                        </svg>
                      </i>
                      <span
                        style={{
                          color: isHref("consultationsupcoming")
                            ? "#1B95BC"
                            : "#a6b0cf",
                          fontWeight: isHref("consultationsupcoming")
                            ? "600"
                            : "400",
                        }}
                        key="t-dashboards"
                      >
                        Upcoming Consultations
                      </span>
                    </Link>
                  </li>

                  
                  <li className="mm-active">
                    <Link
                      className={
                        isHref("consultations-all")
                          ? "waves-effect active"
                          : "waves-effect"
                      }
                      to="/admin/consultations-all"
                    >
                      <i>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M20 4a2 2 0 0 1 2 2v10c0 1.11-.89 2-2 2h4v2H0v-2h4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h16m0 2H4v10h16V6m-8 6c2.21 0 4 .9 4 2v1H8v-1c0-1.1 1.79-2 4-2m0-5a2 2 0 1 1 0 4c-1.11 0-2-.89-2-2s.9-2 2-2Z"
                            fill={
                              isHref("consultations-all")
                                ? "#1B95BC"
                                : "#a6b0cf"
                            }
                          />
                        </svg>
                      </i>
                      <span
                        style={{
                          color: isHref("consultations-all")
                            ? "#1B95BC"
                            : "#a6b0cf",
                          fontWeight: isHref("consultations-all")
                            ? "600"
                            : "400",
                        }}
                        key="t-dashboards"
                      >
                        Consultation History
                      </span>
                    </Link>
                  </li>

                 

                  {/* calender */}
                  <li className="mm-active">
                    <Link
                      to="/admin/calendar"
                      className={
                        isHref("calendar")
                          ? "waves-effect active"
                          : "waves-effect"
                      }
                    >
                      <i className="">
                        <svg
                          height="20"
                          viewBox="0 0 24 24"
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20,8 L20,5 L18,5 L18,6 L16,6 L16,5 L8,5 L8,6 L6,6 L6,5 L4,5 L4,8 L20,8 Z M20,10 L4,10 L4,20 L20,20 L20,10 Z M18,3 L20,3 C21.1045695,3 22,3.8954305 22,5 L22,20 C22,21.1045695 21.1045695,22 20,22 L4,22 C2.8954305,22 2,21.1045695 2,20 L2,5 C2,3.8954305 2.8954305,3 4,3 L6,3 L6,2 L8,2 L8,3 L16,3 L16,2 L18,2 L18,3 Z"
                            fill={isHref("calendar") ? "#1B95BC" : "#a6b0cf"}
                            fill-rule="evenodd"
                          />
                        </svg>
                      </i>
                      <span
                        style={{
                          color: isHref("calendar") ? "#1B95BC" : "#a6b0cf",
                          fontWeight: isHref("calendar") ? "600" : "400",
                        }}
                        key="t-dashboards"
                      >
                        Calendar
                      </span>
                    </Link>
                  </li>

                  {/* transaction */}
                  <li className="mm-active">
                    <Link
                      to="/admin/transactions"
                      className={
                        isHref("transactions")
                          ? "waves-effect active"
                          : "waves-effect"
                      }
                    >
                      <i className="">
                        <svg
                          width="17"
                          height="18"
                          viewBox="0 0 19 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17.1667 19H7.16675"
                            stroke={
                              isHref("transactions") ? "#1B95BC" : "#a6b0cf"
                            }
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M3.66675 14H13.1667C15.0524 14 15.9952 14 16.581 13.4142C17.1667 12.8284 17.1667 11.8856 17.1667 10V5C17.1667 3.11438 17.1667 2.17157 16.581 1.58579C15.9952 1 15.0524 1 13.1667 1H5.16675C3.28113 1 2.33832 1 1.75253 1.58579C1.16675 2.17157 1.16675 3.11438 1.16675 5V16.5C1.16675 15.1193 2.28604 14 3.66675 14ZM13.581 7.41421C14.362 6.63317 14.362 5.36684 13.581 4.58579C12.7999 3.80474 11.5336 3.80474 10.7525 4.58579L8.16675 7.17157L7.58096 6.58579C6.79991 5.80474 5.53358 5.80474 4.75253 6.58579C3.97149 7.36683 3.97149 8.63316 4.75253 9.41421L6.04543 10.7071C7.217 11.8787 9.1165 11.8787 10.2881 10.7071L13.581 7.41421Z"
                            fill={
                              isHref("transactions") ? "#1B95BC" : "#a6b0cf"
                            }
                          />
                          <path
                            d="M16.581 13.4142L15.8739 12.7071L15.8739 12.7071L16.581 13.4142ZM16.581 1.58579L15.8739 2.29289L15.8739 2.29289L16.581 1.58579ZM13.581 4.58579L14.2881 3.87868L14.2881 3.87868L13.581 4.58579ZM13.581 7.41421L12.8739 6.70711L13.581 7.41421ZM10.7525 4.58579L10.0454 3.87868L10.7525 4.58579ZM8.16675 7.17157L7.45964 7.87868L8.16675 8.58579L8.87385 7.87868L8.16675 7.17157ZM7.58096 6.58579L6.87385 7.29289H6.87386L7.58096 6.58579ZM4.75253 6.58579L5.45964 7.29289L5.45964 7.29289L4.75253 6.58579ZM4.75253 9.41421L5.45964 8.70711V8.70711L4.75253 9.41421ZM6.04543 10.7071L5.33832 11.4142L6.04543 10.7071ZM10.2881 10.7071L9.58096 10L10.2881 10.7071ZM13.1667 13H3.66675V15H13.1667V13ZM15.8739 12.7071C15.7977 12.7832 15.6618 12.8774 15.228 12.9357C14.7655 12.9979 14.1378 13 13.1667 13V15C14.0813 15 14.8678 15.0021 15.4945 14.9179C16.1501 14.8297 16.7784 14.631 17.2881 14.1213L15.8739 12.7071ZM16.1667 10C16.1667 10.9711 16.1646 11.5988 16.1024 12.0613C16.0441 12.495 15.95 12.631 15.8739 12.7071L17.2881 14.1213C17.7977 13.6117 17.9965 12.9833 18.0846 12.3278C18.1689 11.701 18.1667 10.9145 18.1667 10H16.1667ZM16.1667 5V10H18.1667V5H16.1667ZM15.8739 2.29289C15.95 2.36902 16.0441 2.50496 16.1024 2.9387C16.1646 3.40121 16.1667 4.02892 16.1667 5H18.1667C18.1667 4.08546 18.1689 3.29896 18.0846 2.67221C17.9965 2.01669 17.7977 1.38834 17.2881 0.878679L15.8739 2.29289ZM13.1667 2C14.1378 2 14.7655 2.00212 15.228 2.06431C15.6618 2.12262 15.7977 2.21677 15.8739 2.29289L17.2881 0.87868C16.7784 0.369017 16.1501 0.170272 15.4945 0.0821405C14.8678 -0.00212371 14.0813 0 13.1667 0V2ZM5.16675 2H13.1667V0H5.16675V2ZM2.45964 2.29289C2.53577 2.21677 2.67171 2.12262 3.10545 2.06431C3.56796 2.00212 4.19567 2 5.16675 2V0C4.25221 0 3.46571 -0.00212371 2.83896 0.0821405C2.18344 0.170272 1.55509 0.369017 1.04543 0.87868L2.45964 2.29289ZM2.16675 5C2.16675 4.02892 2.16887 3.40121 2.23105 2.9387C2.28937 2.50496 2.38352 2.36902 2.45964 2.29289L1.04543 0.87868C0.535766 1.38834 0.33702 2.01669 0.248889 2.67221C0.164624 3.29896 0.166748 4.08546 0.166748 5H2.16675ZM2.16675 16.5V5H0.166748V16.5H2.16675ZM3.66675 13C1.73375 13 0.166748 14.567 0.166748 16.5H2.16675C2.16675 15.6716 2.83832 15 3.66675 15V13ZM12.8739 5.29289C13.2644 5.68342 13.2644 6.31658 12.8739 6.70711L14.2881 8.12132C15.4596 6.94975 15.4596 5.05025 14.2881 3.87868L12.8739 5.29289ZM11.4596 5.29289C11.8502 4.90237 12.4833 4.90237 12.8739 5.29289L14.2881 3.87868C13.1165 2.70711 11.217 2.70711 10.0454 3.87868L11.4596 5.29289ZM8.87385 7.87868L11.4596 5.29289L10.0454 3.87868L7.45964 6.46447L8.87385 7.87868ZM6.87386 7.29289L7.45964 7.87868L8.87385 6.46447L8.28807 5.87868L6.87386 7.29289ZM5.45964 7.29289C5.85017 6.90237 6.48333 6.90237 6.87385 7.29289L8.28807 5.87868C7.1165 4.70711 5.217 4.70711 4.04543 5.87868L5.45964 7.29289ZM5.45964 8.70711C5.06912 8.31658 5.06912 7.68342 5.45964 7.29289L4.04543 5.87868C2.87385 7.05025 2.87385 8.94975 4.04543 10.1213L5.45964 8.70711ZM6.75253 10L5.45964 8.70711L4.04543 10.1213L5.33832 11.4142L6.75253 10ZM9.58096 10C8.79991 10.781 7.53358 10.781 6.75253 10L5.33832 11.4142C6.90042 12.9763 9.43308 12.9763 10.9952 11.4142L9.58096 10ZM12.8739 6.70711L9.58096 10L10.9952 11.4142L14.2881 8.12132L12.8739 6.70711ZM8.16675 18H3.66675V20H8.16675V18ZM0.166748 16.5C0.166748 18.433 1.73375 20 3.66675 20V18C2.83832 18 2.16675 17.3284 2.16675 16.5H0.166748Z"
                            fill={
                              isHref("transactions") ? "#1B95BC" : "#a6b0cf"
                            }
                          />
                        </svg>
                      </i>
                      <span
                        style={{
                          color: isHref("transactions") ? "#1B95BC" : "#a6b0cf",
                          fontWeight: isHref("transactions") ? "600" : "400",
                        }}
                        key="t-dashboards"
                      >
                        Transactions
                      </span>
                    </Link>
                  </li>

                  {/* member */}
                  <li className="mm-active">
                    <Link
                      className={
                        isHref("member", "memberdetails")
                          ? "waves-effect active"
                          : "waves-effect"
                      }
                      to="/admin/member"
                    >
                      <i>
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="12"
                            cy="10"
                            r="3"
                            stroke={
                              isHref("member", "memberdetails")
                                ? "#1B95BC"
                                : "#a6b0cf"
                            }
                            strokeWidth="2"
                            strokeLinecap="round"
                          ></circle>
                          <circle
                            cx="12"
                            cy="12"
                            r="9"
                            stroke={
                              isHref("member", "memberdetails")
                                ? "#1B95BC"
                                : "#a6b0cf"
                            }
                            strokeWidth="2"
                          ></circle>
                          <path
                            d="M17.7805 18.8264C17.9076 18.7566 17.9678 18.6055 17.914 18.4708C17.5284 17.5045 16.7856 16.6534 15.7814 16.0332C14.6966 15.3632 13.3674 15 12 15C10.6326 15 9.30341 15.3632 8.21858 16.0332C7.21444 16.6534 6.4716 17.5045 6.08598 18.4708C6.03223 18.6055 6.09236 18.7566 6.21948 18.8264C9.81971 20.803 14.1803 20.803 17.7805 18.8264Z"
                            fill={
                              isHref("member", "memberdetails")
                                ? "#1B95BC"
                                : "#a6b0cf"
                            }
                          ></path>
                        </svg>
                      </i>
                      <span
                        style={{
                          color: isHref("member", "memberdetails")
                            ? "#1B95BC"
                            : "#a6b0cf",
                          fontWeight: isHref("member", "memberdetails")
                            ? "600"
                            : "400",
                        }}
                        key="t-dashboards"
                      >
                        Members
                      </span>
                    </Link>
                  </li>

                  {/* dentist */}
                  <li className="mm-active">
                    <Link
                      to="/admin/dentist"
                      className={
                        isHref("dentist", "createAdmin", "memberdentistdetails")
                          ? "waves-effect active"
                          : "waves-effect"
                      }
                    >
                      <i>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 448 512"
                        >
                          <path
                            fill="currentColor"
                            d="M224 256a128 128 0 1 0 0-256a128 128 0 1 0 0 256zm-96 55.2C54 332.9 0 401.3 0 482.3C0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7c0-81-54-149.4-128-171.1V362c27.6 7.1 48 32.2 48 62v40c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16v-24c0-17.7-14.3-32-32-32s-32 14.3-32 32v24c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-40c0-29.8 20.4-54.9 48-62v-57.1c-6-.6-12.1-.9-18.3-.9h-91.4c-6.2 0-12.3.3-18.3.9v65.4c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7v-59.1zM144 448a24 24 0 1 0 0-48a24 24 0 1 0 0 48z"
                            fill={isHref("dentist", "memberdentistdetails") ? "#1B95BC" : "#a6b0cf"}
                          />
                        </svg>
                      </i>
                      <span
                        style={{
                          color: isHref("dentist", "createAdmin", "memberdentistdetails")
                            ? "#1B95BC"
                            : "#a6b0cf",
                          fontWeight: isHref("dentist", "createAdmin", "memberdentistdetails")
                            ? "600"
                            : "400",
                        }}
                        key="t-dashboards"
                      >
                        Dentists
                      </span>
                    </Link>
                  </li>

                  {/* become dentist */}
                  <li className="mm-active">
                    <Link
                      to="/admin/dentist-requests"
                      className={
                        isHref("dentist-requests", "createAdmin", "memberdentistdetails")
                          ? "waves-effect active"
                          : "waves-effect"
                      }
                    >
                      <i>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 448 512"
                        >
                          <path
                            fill="currentColor"
                            d="M224 256a128 128 0 1 0 0-256a128 128 0 1 0 0 256zm-96 55.2C54 332.9 0 401.3 0 482.3C0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7c0-81-54-149.4-128-171.1V362c27.6 7.1 48 32.2 48 62v40c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16v-24c0-17.7-14.3-32-32-32s-32 14.3-32 32v24c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-40c0-29.8 20.4-54.9 48-62v-57.1c-6-.6-12.1-.9-18.3-.9h-91.4c-6.2 0-12.3.3-18.3.9v65.4c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7v-59.1zM144 448a24 24 0 1 0 0-48a24 24 0 1 0 0 48z"
                            fill={
                              isHref("dentist-requests") ? "#1B95BC" : "#a6b0cf"
                            }
                          />
                        </svg>
                      </i>
                      <span
                        style={{
                          color: isHref("dentist-requests", "createAdmin")
                            ? "#1B95BC"
                            : "#a6b0cf",
                          fontWeight: isHref("dentist-requests", "createAdmin")
                            ? "600"
                            : "400",
                        }}
                        key="t-dashboards"
                      >
                        Dentist Requests
                      </span>
                    </Link>
                  </li>

                  {/* live chat */}
                  <li className="mm-active">
                    <Link
                      to="/admin/livechat"
                      className={
                        isHref("livechat", "chat")
                          ? "waves-effect active"
                          : "waves-effect"
                      }
                    >
                      <i className="">
                        <svg
                          width="17"
                          height="18"
                          viewBox="0 0 18 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path 
                          d="M16.3259 2.77772L15.4944 3.33329V3.33329L16.3259 2.77772ZM16.3259 13.2223L15.4944 12.6667V12.6667L16.3259 13.2223ZM15.2223 14.3259L14.6667 13.4944H14.6667L15.2223 14.3259ZM11 14.9986L10.9956 13.9986C10.4451 14.001 10 14.4481 10 14.9986H11ZM11 15L11.8944 15.4472C11.9639 15.3084 12 15.1552 12 15H11ZM7 15H6C6 15.1552 6.03615 15.3084 6.10557 15.4472L7 15ZM7 14.9986H8C8 14.4481 7.55494 14.001 7.00436 13.9986L7 14.9986ZM2.77772 14.3259L3.33329 13.4944H3.33329L2.77772 14.3259ZM1.67412 13.2223L2.50559 12.6667L2.50559 12.6667L1.67412 13.2223ZM1.67412 2.77772L2.50559 3.33329L1.67412 2.77772ZM2.77772 1.67412L3.33329 2.50559L2.77772 1.67412ZM15.2223 1.67412L14.6667 2.50559L14.6667 2.50559L15.2223 1.67412ZM18 8C18 6.61635 18.0012 5.50334 17.9106 4.61264C17.8183 3.70523 17.6225 2.91829 17.1573 2.22215L15.4944 3.33329C15.7034 3.64604 15.8446 4.06578 15.9209 4.81505C15.9988 5.58104 16 6.57473 16 8H18ZM17.1573 13.7779C17.6225 13.0817 17.8183 12.2948 17.9106 11.3874C18.0012 10.4967 18 9.38365 18 8H16C16 9.42527 15.9988 10.419 15.9209 11.1849C15.8446 11.9342 15.7034 12.354 15.4944 12.6667L17.1573 13.7779ZM15.7779 15.1573C16.3238 14.7926 16.7926 14.3238 17.1573 13.7779L15.4944 12.6667C15.2755 12.9943 14.9943 13.2755 14.6667 13.4944L15.7779 15.1573ZM11.0044 15.9986C12.0785 15.9939 12.9763 15.9739 13.7267 15.8701C14.4931 15.7642 15.1699 15.5636 15.7779 15.1573L14.6667 13.4944C14.3934 13.6771 14.0378 13.8081 13.4528 13.889C12.8518 13.9721 12.0792 13.9939 10.9956 13.9986L11.0044 15.9986ZM12 15V14.9986H10V15H12ZM10.7889 17.6584L11.8944 15.4472L10.1056 14.5528L9 16.7639L10.7889 17.6584ZM7.21115 17.6584C7.94819 19.1325 10.0518 19.1325 10.7889 17.6584L9 16.7639L9 16.7639L7.21115 17.6584ZM6.10557 15.4472L7.21115 17.6584L9 16.7639L7.89443 14.5528L6.10557 15.4472ZM6 14.9986V15H8V14.9986H6ZM2.22215 15.1573C2.83014 15.5636 3.50685 15.7642 4.2733 15.8701C5.02368 15.9739 5.92154 15.9939 6.99564 15.9986L7.00436 13.9986C5.92075 13.9939 5.14815 13.9721 4.54716 13.889C3.96223 13.8081 3.60665 13.6771 3.33329 13.4944L2.22215 15.1573ZM0.842652 13.7779C1.20744 14.3238 1.6762 14.7926 2.22215 15.1573L3.33329 13.4944C3.00572 13.2755 2.72447 12.9943 2.50559 12.6667L0.842652 13.7779ZM0 8C0 9.38365 -0.0012089 10.4967 0.0893996 11.3874C0.181708 12.2948 0.377503 13.0817 0.842652 13.7779L2.50559 12.6667C2.29662 12.354 2.15535 11.9342 2.07913 11.1849C2.00121 10.419 2 9.42527 2 8H0ZM0.842652 2.22215C0.377503 2.91829 0.181708 3.70523 0.0893996 4.61264C-0.0012089 5.50334 0 6.61635 0 8H2C2 6.57473 2.00121 5.58104 2.07913 4.81505C2.15535 4.06578 2.29662 3.64604 2.50559 3.33329L0.842652 2.22215ZM2.22215 0.842652C1.6762 1.20744 1.20744 1.6762 0.842652 2.22215L2.50559 3.33329C2.72447 3.00572 3.00572 2.72447 3.33329 2.50559L2.22215 0.842652ZM8 0C6.61635 0 5.50334 -0.0012089 4.61264 0.0893996C3.70523 0.181708 2.91829 0.377503 2.22215 0.842652L3.33329 2.50559C3.64604 2.29662 4.06578 2.15535 4.81505 2.07913C5.58104 2.00121 6.57473 2 8 2V0ZM10 0H8V2H10V0ZM15.7779 0.842652C15.0817 0.377503 14.2948 0.181708 13.3874 0.0893996C12.4967 -0.0012089 11.3836 0 10 0V2C11.4253 2 12.419 2.00121 13.1849 2.07913C13.9342 2.15535 14.354 2.29662 14.6667 2.50559L15.7779 0.842652ZM17.1573 2.22215C16.7926 1.6762 16.3238 1.20744 15.7779 0.842652L14.6667 2.50559C14.9943 2.72447 15.2755 3.00572 15.4944 3.33329L17.1573 2.22215Z"
                            fill={
                              isHref("livechat", "chat") ? "#1B95BC" : "#a6b0cf"
                            }
                          />
                          <circle
                            cx="13"
                            cy="8"
                            r="1"
                            fill="#A3AED0"
                            stroke={
                              isHref("livechat", "chat") ? "#1B95BC" : "#a6b0cf"
                            }
                            strokeLinecap="round"
                          />
                          <circle
                            cx="9"
                            cy="8"
                            r="1"
                            fill="#A3AED0"
                            stroke={
                              isHref("livechat", "chat") ? "#1B95BC" : "#a6b0cf"
                            }
                            strokeLinecap="round"
                          />
                          <circle
                            cx="5"
                            cy="8"
                            r="1"
                            fill="#A3AED0"
                            stroke={
                              isHref("livechat", "chat") ? "#1B95BC" : "#a6b0cf"
                            }
                            strokeLinecap="round"
                          />
                        </svg>
                      </i>
                      <span
                        style={{
                          color: isHref("livechat", "chat")
                            ? "#1B95BC"
                            : "#a6b0cf",
                          fontWeight: isHref("livechat", "chat")
                            ? "600"
                            : "400",
                        }}
                        key="t-dashboards"
                      >
                        Live Chat
                      </span>
                    </Link>
                  </li>

                  {/* report issue */}
                  <li className="mm-active">
                    <Link
                      to="/admin/report-issue"
                      className={
                        isHref("report-issue", "createAdmin")
                          ? "waves-effect active"
                          : "waves-effect"
                      }
                    >
                      <i className="">
                        <svg
                          width="17"
                          height="18"
                          viewBox="0 0 18 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M16.3259 2.77772L15.4944 3.33329V3.33329L16.3259 2.77772ZM16.3259 13.2223L15.4944 12.6667V12.6667L16.3259 13.2223ZM15.2223 14.3259L14.6667 13.4944H14.6667L15.2223 14.3259ZM11 14.9986L10.9956 13.9986C10.4451 14.001 10 14.4481 10 14.9986H11ZM11 15L11.8944 15.4472C11.9639 15.3084 12 15.1552 12 15H11ZM7 15H6C6 15.1552 6.03615 15.3084 6.10557 15.4472L7 15ZM7 14.9986H8C8 14.4481 7.55494 14.001 7.00436 13.9986L7 14.9986ZM2.77772 14.3259L3.33329 13.4944H3.33329L2.77772 14.3259ZM1.67412 13.2223L2.50559 12.6667L2.50559 12.6667L1.67412 13.2223ZM1.67412 2.77772L2.50559 3.33329L1.67412 2.77772ZM2.77772 1.67412L3.33329 2.50559L2.77772 1.67412ZM15.2223 1.67412L14.6667 2.50559L14.6667 2.50559L15.2223 1.67412ZM18 8C18 6.61635 18.0012 5.50334 17.9106 4.61264C17.8183 3.70523 17.6225 2.91829 17.1573 2.22215L15.4944 3.33329C15.7034 3.64604 15.8446 4.06578 15.9209 4.81505C15.9988 5.58104 16 6.57473 16 8H18ZM17.1573 13.7779C17.6225 13.0817 17.8183 12.2948 17.9106 11.3874C18.0012 10.4967 18 9.38365 18 8H16C16 9.42527 15.9988 10.419 15.9209 11.1849C15.8446 11.9342 15.7034 12.354 15.4944 12.6667L17.1573 13.7779ZM15.7779 15.1573C16.3238 14.7926 16.7926 14.3238 17.1573 13.7779L15.4944 12.6667C15.2755 12.9943 14.9943 13.2755 14.6667 13.4944L15.7779 15.1573ZM11.0044 15.9986C12.0785 15.9939 12.9763 15.9739 13.7267 15.8701C14.4931 15.7642 15.1699 15.5636 15.7779 15.1573L14.6667 13.4944C14.3934 13.6771 14.0378 13.8081 13.4528 13.889C12.8518 13.9721 12.0792 13.9939 10.9956 13.9986L11.0044 15.9986ZM12 15V14.9986H10V15H12ZM10.7889 17.6584L11.8944 15.4472L10.1056 14.5528L9 16.7639L10.7889 17.6584ZM7.21115 17.6584C7.94819 19.1325 10.0518 19.1325 10.7889 17.6584L9 16.7639L9 16.7639L7.21115 17.6584ZM6.10557 15.4472L7.21115 17.6584L9 16.7639L7.89443 14.5528L6.10557 15.4472ZM6 14.9986V15H8V14.9986H6ZM2.22215 15.1573C2.83014 15.5636 3.50685 15.7642 4.2733 15.8701C5.02368 15.9739 5.92154 15.9939 6.99564 15.9986L7.00436 13.9986C5.92075 13.9939 5.14815 13.9721 4.54716 13.889C3.96223 13.8081 3.60665 13.6771 3.33329 13.4944L2.22215 15.1573ZM0.842652 13.7779C1.20744 14.3238 1.6762 14.7926 2.22215 15.1573L3.33329 13.4944C3.00572 13.2755 2.72447 12.9943 2.50559 12.6667L0.842652 13.7779ZM0 8C0 9.38365 -0.0012089 10.4967 0.0893996 11.3874C0.181708 12.2948 0.377503 13.0817 0.842652 13.7779L2.50559 12.6667C2.29662 12.354 2.15535 11.9342 2.07913 11.1849C2.00121 10.419 2 9.42527 2 8H0ZM0.842652 2.22215C0.377503 2.91829 0.181708 3.70523 0.0893996 4.61264C-0.0012089 5.50334 0 6.61635 0 8H2C2 6.57473 2.00121 5.58104 2.07913 4.81505C2.15535 4.06578 2.29662 3.64604 2.50559 3.33329L0.842652 2.22215ZM2.22215 0.842652C1.6762 1.20744 1.20744 1.6762 0.842652 2.22215L2.50559 3.33329C2.72447 3.00572 3.00572 2.72447 3.33329 2.50559L2.22215 0.842652ZM8 0C6.61635 0 5.50334 -0.0012089 4.61264 0.0893996C3.70523 0.181708 2.91829 0.377503 2.22215 0.842652L3.33329 2.50559C3.64604 2.29662 4.06578 2.15535 4.81505 2.07913C5.58104 2.00121 6.57473 2 8 2V0ZM10 0H8V2H10V0ZM15.7779 0.842652C15.0817 0.377503 14.2948 0.181708 13.3874 0.0893996C12.4967 -0.0012089 11.3836 0 10 0V2C11.4253 2 12.419 2.00121 13.1849 2.07913C13.9342 2.15535 14.354 2.29662 14.6667 2.50559L15.7779 0.842652ZM17.1573 2.22215C16.7926 1.6762 16.3238 1.20744 15.7779 0.842652L14.6667 2.50559C14.9943 2.72447 15.2755 3.00572 15.4944 3.33329L17.1573 2.22215Z"
                            fill={
                              isHref("report-issue", "chat") ? "#1B95BC" : "#a6b0cf"
                            }
                          />
                          <circle
                            cx="13"
                            cy="8"
                            r="1"
                            fill="#A3AED0"
                            stroke={
                              isHref("report-issue", "chat") ? "#1B95BC" : "#a6b0cf"
                            }
                            strokeLinecap="round"
                          />
                          <circle
                            cx="9"
                            cy="8"
                            r="1"
                            fill="#A3AED0"
                            stroke={
                              isHref("report-issue", "chat") ? "#1B95BC" : "#a6b0cf"
                            }
                            strokeLinecap="round"
                          />
                          <circle
                            cx="5"
                            cy="8"
                            r="1"
                            fill="#A3AED0"
                            stroke={
                              isHref("report-issue", "chat") ? "#1B95BC" : "#a6b0cf"
                            }
                            strokeLinecap="round"
                          />
                        </svg>
                      </i>
                      <span
                        style={{
                          color: isHref("report-issue", "createAdmin")
                            ? "#1B95BC"
                            : "#a6b0cf",
                          fontWeight: isHref("report-issue", "createAdmin")
                            ? "600"
                            : "400",
                        }}
                        key="t-dashboards"
                      >
                        Help & Support
                      </span>
                    </Link>
                  </li>

                  {/* blog */}
                  <li className="mm-active">
                    <Link
                      to="/admin/blog"
                      className={
                        isHref("blog") ? "waves-effect active" : "waves-effect"
                      }
                    >
                      <i>
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4 13H10C10.55 13 11 12.55 11 12V4C11 3.45 10.55 3 10 3H4C3.45 3 3 3.45 3 4V12C3 12.55 3.45 13 4 13ZM4 21H10C10.55 21 11 20.55 11 20V16C11 15.45 10.55 15 10 15H4C3.45 15 3 15.45 3 16V20C3 20.55 3.45 21 4 21ZM14 21H20C20.55 21 21 20.55 21 20V12C21 11.45 20.55 11 20 11H14C13.45 11 13 11.45 13 12V20C13 20.55 13.45 21 14 21ZM13 4V8C13 8.55 13.45 9 14 9H20C20.55 9 21 8.55 21 8V4C21 3.45 20.55 3 20 3H14C13.45 3 13 3.45 13 4Z"
                            fill={isHref("blog") ? "#1B95BC" : "#a6b0cf"}
                          />
                        </svg>
                      </i>
                      <span
                        style={{
                          color: isHref("blog") ? "#1B95BC" : "#a6b0cf",
                          fontWeight: isHref("blog") ? "600" : "400",
                        }}
                        key="t-dashboards"
                      >
                        Blogs
                      </span>
                    </Link>
                  </li>

                  {/* manage admin */}
                  <li className="mm-active">
                    <Link
                      to="/admin/manageAdmins"
                      className={
                        isHref("manageAdmins", "createAdmin")
                          ? "waves-effect active"
                          : "waves-effect"
                      }
                    >
                      <i className="">
                        <svg
                          fill="none"
                          height="22"
                          viewBox="0 0 24 24"
                          width="22"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.8094 13.0002L4 12.999C2.896 12.999 2 13.895 2 14.999V16.5L2.00545 16.7296C2.1647 20.044 5.77787 21 8.5 21C9.53057 21 10.6887 20.863 11.739 20.513C11.5082 20.0726 11.3264 19.6025 11.2024 19.1096C10.5039 19.3342 9.68108 19.4686 8.8174 19.4951L8.5 19.5L8.18258 19.4951C6.91951 19.4563 5.74315 19.1869 4.917 18.742C3.95 18.222 3.5 17.509 3.5 16.5V14.999L3.51 14.898C3.53528 14.7733 3.6028 14.689 3.646 14.645C3.69 14.6018 3.77496 14.5343 3.89934 14.509L4 14.499L11.7323 14.4999C12.0194 13.949 12.3832 13.4444 12.8094 13.0002ZM13 6.5C13 4.015 10.985 2 8.5 2C6.015 2 4 4.015 4 6.5C4 8.985 6.015 11 8.5 11C10.985 11 13 8.985 13 6.5ZM5.5 6.5C5.5 4.846 6.846 3.5 8.5 3.5C10.154 3.5 11.5 4.846 11.5 6.5C11.5 8.154 10.154 9.5 8.5 9.5C6.846 9.5 5.5 8.154 5.5 6.5ZM21 7.5C21 5.567 19.433 4 17.5 4C15.567 4 14 5.567 14 7.5C14 9.433 15.567 11 17.5 11C19.433 11 21 9.433 21 7.5ZM15.5 7.5C15.5 6.397 16.397 5.5 17.5 5.5C18.603 5.5 19.5 6.397 19.5 7.5C19.5 8.603 18.603 9.5 17.5 9.5C16.397 9.5 15.5 8.603 15.5 7.5ZM16.0627 12.9013L15.5639 12.3765C15.0203 12.5967 14.5204 12.9068 14.0811 13.2892L14.2792 13.9754C14.5939 15.0656 13.9396 16.1991 12.838 16.4716L12.2538 16.6161C12.2089 16.9038 12.1855 17.199 12.1855 17.4998C12.1855 17.8145 12.2111 18.123 12.2601 18.4232L12.7996 18.5532C13.9121 18.8211 14.5734 19.9661 14.2496 21.0636L14.0633 21.6949C14.5024 22.0805 15.0029 22.3937 15.5474 22.6165L16.0407 22.0977C16.8293 21.2685 18.1515 21.2687 18.9398 22.0982L19.4385 22.623C19.9821 22.4027 20.4821 22.0925 20.9213 21.7101L20.7233 21.0242C20.4085 19.9339 21.0629 18.8005 22.1645 18.528L22.7482 18.3835C22.7931 18.0958 22.8165 17.8006 22.8165 17.4998C22.8165 17.1851 22.7909 16.8765 22.7418 16.5762L22.2029 16.4464C21.0904 16.1785 20.4291 15.0335 20.7529 13.9359L20.9391 13.3051C20.4999 12.9193 19.9995 12.6061 19.4549 12.3833L18.9618 12.9018C18.1732 13.7311 16.8509 13.7309 16.0627 12.9013ZM16.0513 17.4998C16.0513 16.6714 16.7004 15.9998 17.501 15.9998C18.3016 15.9998 18.9507 16.6714 18.9507 17.4998C18.9507 18.3282 18.3016 18.9998 17.501 18.9998C16.7004 18.9998 16.0513 18.3282 16.0513 17.4998Z"
                            fill={
                              isHref("manageAdmins", "createAdmin")
                                ? "#1B95BC"
                                : "#a6b0cf"
                            }
                          />
                        </svg>
                      </i>
                      <span
                        style={{
                          color: isHref("manageAdmins", "createAdmin")
                            ? "#1B95BC"
                            : "#a6b0cf",
                          fontWeight: isHref("manageAdmins", "createAdmin")
                            ? "600"
                            : "400",
                        }}
                        key="t-dashboards"
                      >
                        Manage Admins
                      </span>
                    </Link>
                  </li>

                  {/* <li className="mm-active">
                    <Link
                      to="/admin/dentist-requests"
                      className={
                        isHref("dentist-requests", "createAdmin")
                          ? "waves-effect active"
                          : "waves-effect"
                      }
                    >
                      <i>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M7 2C4 2 2 5 2 8c0 2.11 1 5 2 6s2 8 4 8c4.54 0 2-7 4-7s-.54 7 4 7c2 0 3-7 4-8s2-3.89 2-6c0-3-2-6-5-6s-3 1-5 1s-2-1-5-1Z"
                            fill={
                              isHref("dentist-requests") ? "#1B95BC" : "#a6b0cf"
                            }
                          />
                        </svg>
                      </i>
                      <span
                        style={{
                          color: isHref("dentist-requests", "createAdmin")
                            ? "#1B95BC"
                            : "#a6b0cf",
                          fontWeight: isHref("dentist-requests", "createAdmin")
                            ? "600"
                            : "400",
                        }}
                        key="t-dashboards"
                      >
                        Dentist Requests
                      </span>
                    </Link>
                  </li> */}
                </>
              )}
            </ul>
            <div className="logout-link">
              <Link to="/adminlogin" onClick={handleLogout}>
                Log Out
              </Link>
            </div>
          </div>
        </div>
        {/* <!-- Sidebar --> */}
      </div>
    </div>
  );
};

export default Sidebar;
